<template>
    <div name="booking" class="booking" v-if="step === 0" >
        <img class="image" src="../../assets/showcase/xi/booking/list/1.png"  @click="goHome"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/2.png" />
        <img class="image" src="../../assets/showcase/xi/booking/list/3.png" @click="selectProfile" />
        <img class="image" src="../../assets/showcase/xi/booking/list/4.png" />
        <!-- <img class="image" src="../../assets/showcase/xi/booking/list/5.png" @click="selectProfile"/>
        <img class="image" src="../../assets/showcase/xi/booking/list/6.png" /> -->
    </div>
    <div class="booking" v-else-if="step === 1" >
        <img class="image" src="../../assets/showcase/xi/booking/profile/1.png" @click="step = 0" />
        <img class="image" src="../../assets/showcase/xi/booking/profile/2.png" />
        <img class="image" src="../../assets/showcase/xi/booking/profile/3.png" />
        <img class="image" src="../../assets/showcase/xi/booking/profile/4.png" />
        <div class="bottom-button">
            <img class="image" src="../../assets/showcase/xi/booking/profile/5.png" />
            <div class="button1" @click="step = 5"></div>
            <div class="button2" @click="bookingStart"></div>
        </div>
    </div>
    <div class="booking" v-else-if="step === 2">
        <img class="image" src="../../assets/showcase/xi/booking/calendar/1.png" @click="step = 1"/>
        <img class="image" src="../../assets/showcase/xi/booking/calendar/2.png" />
        <calendar 
            @dateSelected="dateSelect"
        />
        <img class="image" src="../../assets/showcase/xi/booking/calendar/3.png" />
    </div>
    <div class="booking" v-else-if="step === 3" >
        <img class="image" src="../../assets/showcase/xi/booking/department/1.png" />
        <img class="image" src="../../assets/showcase/xi/booking/department/2.png" />
        <img class="image" src="../../assets/showcase/xi/booking/department/3.png" @click="step = 2"/>
        <img class="image" src="../../assets/showcase/xi/booking/department/4.png" />
        <img class="image" src="../../assets/showcase/xi/booking/department/5.png" @click="completeCheck" />
        <img class="image" src="../../assets/showcase/xi/booking/department/6.png" />
    </div>
    <div class="booking" v-else-if="step === 4" >
        <img class="image" src="../../assets/showcase/xi/booking/complete/1.png" @click="step = 3"/>
        <div style="position: fixed; bottom: calc(100vw * 120 / 375); width: calc(100% - 12.4px - 7.1vw);  display: flex;flex-direction: column;">
            <img class="image" src="../../assets/showcase/xi/booking/complete/2.png" />
            <img class="image" src="../../assets/showcase/xi/booking/complete/3.png" @click="goHistory"/>
        </div>
    </div> 
    <div class="booking" v-else-if="step === 5" >
        <img class="image" src="../../assets/showcase/xi/my/1/1.png" @click="step = 1"/>
        <img class="image" src="../../assets/showcase/xi/my/1/2.png" />
        <img class="image" src="../../assets/showcase/xi/my/1/3.png" @click="step = 1"/>
        <img class="image" src="../../assets/showcase/xi/my/1/4.png" />
    </div>   
</template>

<script>
import Calendar from '@/components/showcase/Calendar';
export default {
  components: { Calendar },
    name: 'booking',
    props: ['outStep'],
    data: function()
    {
        return {
            step: 0,
            preStep: 0
        }
    },
    mounted: function()
    {
        this.scrollToTop();
        if(this.outStep !== null)
        {
            this.step = this.outStep
        }
    },
    methods: {
        scrollToTop() {
            const el = document.getElementById('app')
            if (el) {
                el.scrollTo({
                    top: 0               
                })
            }
        },
        selectProfile: function()
        {
            this.preStep = this.step
            this.step = 1;
        },
        bookingStart: function()
        {
            this.scrollToTop();
            this.preStep = this.step
            this.step = 2;
        },
        profileUpdate: function()
        {
            this.preStep = this.step
            this.step = 5;
        },
        dateSelect: function()
        {
            this.scrollToTop();
            this.preStep = this.step
            this.step = 3;
        },
        completeCheck: function()
        {
            this.preStep = this.step
            this.step = 4;
        },
        goHistory: function()
        {
            this.$emit('goHistory')
        },
        goHome: function()
        {
            this.$emit('goHome')
        }
    }
}
</script>

<style scoped>
    .image {
        width: 100%;
    }
    
    .booking {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        background: #FFF;
    }
    .bottom-button {
        bottom: calc(100vw * 120 / 375);
        position: fixed; 
        width: calc(100% - 12.4px - 8vw);
    }
    .button1 {
        position: absolute;
        width: 50%;
        height: 100%;
        top: 0;
        left: 0;
    }   
    .button2 {
        position: absolute;
        width: 50%;
        height: 100%;
        top: 0;
        right: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Booking.vue